<template>
  <div>
    <LernbausteinPfade
      :id="LBSTPfadeBeispiele[0].id"
      :workOrder="LBSTPfadeBeispiele[0].workOrder"
      :image="LBSTPfadeBeispiele[0].image"
      :mediaDescription="LBSTPfadeBeispiele[0].mediaDescription"
      :audio="LBSTPfadeBeispiele[0].audio"
      :elements="LBSTPfadeBeispiele[0].elements"
      :responses="LBSTPfadeBeispiele[0].responses"
      pupilName="Max"
    />
    <br />
    <br />
    <br />
    <LernbausteinGruppen
      :id="LBSTGruppe.id"
      :checkAfterHowManyItems="LBSTGruppe.checkAfterHowManyItems"
      :checkAfterExactItemCount="LBSTGruppe.checkAfterExactItemCount"
      :showGroupNames="LBSTGruppe.showGroupNames"
      :workOrder="LBSTGruppe.workOrder"
      :possibleCategories="LBSTGruppe.possibleCategories"
      :elements="LBSTGruppe.elements"
      :responses="LBSTGruppe.responses"
      :optionICON="true"
    ></LernbausteinGruppen>

    <LernbausteinStempeln
        :id="LBSTStempeln.id"
        :workOrder="LBSTStempeln.workOrder"
        :elements="LBSTStempeln.elements"
        :image="LBSTStempeln.image"
      ></LernbausteinStempeln>
  </div>
</template>

<script>
import LernbausteinPfade from "@/components/faledia/explorativeElemente/LernbausteinPfade";
import LernbausteinGruppen from "@/components/faledia/explorativeElemente/LernbausteinGruppen";
import LernbausteinStempeln from "@/components/faledia/explorativeElemente/LernbausteinStempeln";
import PfadeBeispiele from "../seiten/einMalEins/LBST/LBST_Pfade_Miriam";
import Stempeln from "../seiten/zahlenrechnen/LBST/LBST_Stempeln_Diagnose2";
import GruppenBeispiel from "./LBSTGruppenTest";
export default {
  components: {
    LernbausteinPfade,
    LernbausteinGruppen,
    LernbausteinStempeln,
  },
  data: () => ({
    LBSTPfadeBeispiele: [PfadeBeispiele],
    LBSTGruppe: GruppenBeispiel,
    LBSTStempeln: Stempeln,
  }),
};
</script>

<style></style>
